import { useCallback, useState } from 'react';

type UseIsPatchLoadingProps = Partial<{
    onFailure: VoidFunction;
    onSuccess: VoidFunction;
}>;

export const useIsPatchLoading = ({ onFailure, onSuccess }: UseIsPatchLoadingProps = {}) => {
    const [isPatchLoading, setIsPatchLoading] = useState(false);

    const waitForPatchComplete = useCallback(
        async (promise: Promise<boolean> | Promise<boolean[]>) => {
            setIsPatchLoading(true);

            try {
                const result = await promise;
                const results = Array.isArray(result) ? result : [result];

                if (results.some((result) => !result)) {
                    throw false;
                }

                onSuccess?.();

                return true;
            } catch (_error) {
                onFailure?.();

                return false;
            } finally {
                setIsPatchLoading(false);
            }
        },
        [onFailure, onSuccess]
    );

    return [isPatchLoading, waitForPatchComplete] as const;
};
